import React from "react";
import { Dialog, Flex, Text, TextField, Button, Select } from "@radix-ui/themes";

const ENVIRONMENT_OPTIONS = [
  { value: "demo", label: "Demo" },
  { value: "us", label: "United States" },
  { value: "eu", label: "Europe" },
];

export function AuthSevenRoomsDialog({
  isOpen,
  onOpenChange,
  onCancel,
  onSave,
  clientId,
  clientSecret,
  environment,
  onClientIdChange,
  onClientSecretChange,
  onEnvironmentChange,
  isClientIdValid,
  isClientSecretValid,
  isEnvironmentValid,
  isLoading,
  title = "Connect SevenRooms",
}) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="600px" maxHeight="690px" align="center">
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          SevenRooms issues API credentials through your CSM or partnership contact. These are not
          your dashboard email and password, and this is not a “Connect with SevenRooms” OAuth
          flow. Paste the client ID and client secret, then choose whether this restaurant uses
          Demo, US, or EU.
        </Dialog.Description>

        <Flex direction="column" gap="3" mt="2" style={{ alignSelf: "stretch", width: "100%" }}>
          <Flex direction="column" gap="1">
            <Text size="2" weight="medium">
              Client ID
            </Text>
            <TextField.Root
              value={clientId}
              onChange={(event) =>
                onClientIdChange({
                  ...event,
                  target: { ...event.target, value: event.target.value.trim() },
                })
              }
              placeholder="Paste your SevenRooms client ID"
              style={{ width: "100%" }}
              size="2"
              variant="surface"
            />
            {!isClientIdValid && (
              <Text size="1" weight="regular" color="red">
                Please enter a valid client ID.
              </Text>
            )}
          </Flex>

          <Flex direction="column" gap="1">
            <Text size="2" weight="medium">
              Client secret
            </Text>
            <TextField.Root
              type="password"
              value={clientSecret}
              onChange={(event) =>
                onClientSecretChange({
                  ...event,
                  target: { ...event.target, value: event.target.value.trim() },
                })
              }
              placeholder="Paste your SevenRooms client secret"
              style={{ width: "100%" }}
              size="2"
              variant="surface"
            />
            {!isClientSecretValid && (
              <Text size="1" weight="regular" color="red">
                Please enter a valid client secret.
              </Text>
            )}
          </Flex>

          <Flex direction="column" gap="1">
            <Text size="2" weight="medium">
              Environment
            </Text>
            <Select.Root value={environment} onValueChange={onEnvironmentChange} size="2">
              <Select.Trigger style={{ width: "100%" }} variant="surface" placeholder="Select environment" />
              <Select.Content>
                {ENVIRONMENT_OPTIONS.map((option) => (
                  <Select.Item key={option.value} value={option.value}>
                    {option.label}
                  </Select.Item>
                ))}
              </Select.Content>
            </Select.Root>
            {!isEnvironmentValid && (
              <Text size="1" weight="regular" color="red">
                Please select demo, United States, or Europe.
              </Text>
            )}
          </Flex>
        </Flex>

        <Flex
          style={{ alignSelf: "stretch", width: "100%" }}
          display="flex"
          justify="end"
          align="center"
          mt="4"
          gap="3"
        >
          <Dialog.Close>
            <Button onClick={onCancel} size="2" variant="soft" color="gray">
              Cancel
            </Button>
          </Dialog.Close>
          <Button
            onClick={() => onSave()}
            size="2"
            variant="soft"
            color="accent"
            loading={isLoading}
          >
            Save and continue
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
